import React from 'react';

import {
    Accordion,
    AccordionDetails,
    AccordionSummary
} from '@mui/material';

export const styles = {
    accordionBlock: {
        color: 'white.main',
        display: 'flex',
        fontSize: '12px',
        padding: '0',
        margin: '0',
        justifyContent: 'space-between',
        flexDirection: 'column',
        backgroundColor: 'black.main',
        borderLeft: 0
    },
    accordionBlockExpanded: {
        borderLeft: '10px solid',
        borderLeftColor: 'green.main',
        backgroundColor: 'rgba(60, 60, 60, 0.5)',
        backdropFilter: 'saturate(200%) blur(0.4rem)',
    },
    accordionHeaderBlock: {
        minHeight: 70,
        color: 'white.main',
        fontSize: '16px',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'space-between',
        WebkitBoxAlign: 'center',
        alignItems: 'center',
        width: '100%',
        padding: '0 0 0 20px',
        backgroundColor: 'grey.darkest',
        borderBottom: '1px solid',
        borderBottomColor: 'grey.darker',
    },
    accordionExpandButton: {
        color: 'white.main',
        borderRadius: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        width: '70px',
        height: '40px',
    },
    accordionDetails: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        padding: 0,
        margin: 0,
        backgroundColor: 'grey.darker',
    },
};

export const CustomAccordion = ({children, expandedStyle = false, ...rest}) => {
    return <Accordion
        TransitionProps={{unmountOnExit: true}}
        disableGutters
        sx={expandedStyle ? styles.accordionBlockExpanded : styles.accordionBlock}
        {...rest}
    >
        {children}
    </Accordion>;
};

export const CustomAccordionSummary = ({children, ...rest}) => {
    return <AccordionSummary
        sx={styles.accordionHeaderBlock}
        {...rest}
    >
        {children}
    </AccordionSummary>;
};

export const CustomAccordionDetails = ({children}) => {
    return <AccordionDetails sx={styles.accordionDetails}>
        {children}
    </AccordionDetails>;
};
